// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowsAltOutlinedSvg from "@fishx/icons-svg/es/asn/ArrowsAltOutlined";
import FishxIcon from '../components/FishxIcon';

var ArrowsAltOutlined = function ArrowsAltOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowsAltOutlinedSvg
  }));
};

ArrowsAltOutlined.displayName = 'ArrowsAltOutlined';
export default React.forwardRef(ArrowsAltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ArrowsAltOutlined.js
// module id = 2021
// module chunks = 0